import './index.css';
import { Form, Input, Button } from 'antd';
import * as S from './styles';
import { Typography, Spin } from 'antd';
import { toast } from 'react-toastify';
import { LoadingOutlined } from '@ant-design/icons';
import api from '../../service/api';
import { useHistory } from "react-router-dom";
import { useState } from 'react';
import { EnvelopeSimple, Lock } from 'phosphor-react';

export type LoginForm = {
  email: string,
  senha: string,
}

const Login: React.FC = () => {
  const [isSpinning, setIsSpinning] = useState<boolean>(false)
  let history = useHistory();
  const onFinish = async (values: LoginForm) => {
    setIsSpinning(true)
    await api.post(`api/login`, values).then(function (response) {
      if (response.data.messageError) {
        toast.error(`${response.data.messageError}`)
      }
      if (response.data.cliente.tipoDeUsuario === 1) {
        localStorage.setItem('user', JSON.stringify(response.data.cliente.tipoDeUsuario));
        localStorage.setItem('cliente', JSON.stringify(response.data.cliente));
        setIsSpinning(false)
        history.push("/admin")
        return
      }
      localStorage.setItem('user', JSON.stringify(response.data.cliente.tipoDeUsuario));
      localStorage.setItem('cliente', JSON.stringify(response.data.cliente));
      setIsSpinning(false)
      history.push("/painel")
    })
      .catch(function (error) {
        setIsSpinning(false);

        if (error.response) {
          // O servidor respondeu com um status HTTP fora do intervalo 2xx
          toast.error(`Erro ${error.response.status}: ${error.response.data?.message || 'Falha na requisição'}`);
        } else if (error.request) {
          // A requisição foi feita, mas não houve resposta
          toast.error('Nenhuma resposta do servidor. Verifique sua conexão.');
        } else {
          // Algo aconteceu ao configurar a requisição
          toast.error(`Erro: ${error.message}`);
        }
      });
  };

  const { Title } = Typography;

  const onFinishFailed = (errorInfo: any) => {
  };

  const antIcon = <LoadingOutlined style={{ fontSize: 34, color: "#2ce414" }} spin />

  return (
    <Spin indicator={antIcon} spinning={isSpinning}>
      <div
        style={{
          position: 'relative',
          display: "flex",
          justifyContent: "center",
          alignItems: 'center',
          height: "100vh",
          backgroundColor: "#f7f8f9",
          overflow: 'hidden',
        }}
      >
        {/* Detalhes fora do Container e com z-index menor */}
        <S.DetalheSuperiorDireito />
        <S.DetalheInferiorEsquerdo />

        {/* Container com z-index maior */}
        <S.Container>
          <S.LadoEsquerdo>
            <S.ContainerLogo>
              <h1 style={{ fontSize: "35px", fontWeight: "bold" }}>Painel</h1>
              <S.Logo src="/Logo.webp" alt="Assessoria de Cartões" />
            </S.ContainerLogo>

          </S.LadoEsquerdo>
          <S.LadoDireito>
            <Title level={3}>Bem-vindo(a)!</Title>
            <p>Faça login para acessar sua conta</p>
            <div style={{ width: "100%", maxWidth: "360px", margin: "0 auto" }}>
              <Form
                name="basic"
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                style={{ width: '400px' }}
              >
                <Form.Item
                  name="email"
                  rules={[{ required: true, message: 'Insira seu E-mail' }]}
                >
                  <S.CustomInput
                    placeholder="E-mail"
                    prefix={<EnvelopeSimple size={20} color="#999" weight="regular" />}
                  />
                </Form.Item>

                <Form.Item
                  name="senha"
                  rules={[{ required: true, message: 'Insira sua senha' }]}
                >
                  <S.CustomPasswordInput
                    placeholder="Senha"
                    prefix={<Lock size={20} color="#999" weight="regular" />}
                  />
                </Form.Item>

                <Form.Item>
                  <S.CustomButton type="primary" htmlType="submit" block>
                    Entrar
                  </S.CustomButton>
                </Form.Item>
              </Form>
            </div>
          </S.LadoDireito>
        </S.Container>
      </div>
    </Spin>
  );
};

export default Login;